import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import {
  createWarehouse,
  deleteWarehouse,
  getWarehouseList,
  updateWarehouse,
  getListCountry,
  getAllWarehouseSync,
} from "../../services/MoloniServices";
import Select from "react-select";

const WarehouseMoloni = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const navigate = useNavigate();

  const location = useLocation();
  const [activeTab, setActiveTab] = useState("tpsoft");

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: "269134",
    created_from: activeTab === "tpsoft" ? 1 : 2,
  });
  const { t } = useTranslation();

  const [totalRecords, setTotalRecords] = useState(0);
  const [warehouseList, setWarehouseList] = useState([]);
  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delType, setDelType] = useState("");
  const [modifyModal, setModifyModal] = useState(false);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [wareHouseData, setWarehouseData] = useState({
    id: "",
    title: "",
    is_default: 0,
    code: "",
    address: "",
    city: "",
    zip_code: "",
    country_id: "",
    phone: "",
    fax: "",
    contact_name: "",
    contact_email: "",
    moloni_id: "",
  });

  let errorsObj = {
    name: "",
    business_name: "",
    email: "",
    address: "",
    city: "",
    zip_code: "",
    phone: "",
    fax: "",
    website: "",
    notes: "",
    documents_footnote: "",
    email_sender_name: "",
    email_sender_address: "",
    country_id: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [timeZoneList, setTimeZoneList] = useState([]);
  const [isWareHouseLoading, setIsWareHouseLoading] = useState(false);

  const handleTabChange = (tab) => {
    setActiveTab(tab);

    setParams((prevParams) => ({
      ...prevParams,
      created_from: tab === "tpsoft" ? 1 : 2,
    }));
  };

  const handleAddModal = () => {
    setModifyModal(true);
  };

  const handleCloseModal = () => {
    setModifyModal(false);
    setWarehouseData({
      id: "",
      name: "",
      business_name: "",
      email: "",
      address: "",
      city: "",
      zip_code: "",
      phone: "",
      fax: "",
      website: "",
      notes: "",
      documents_footnote: "",
      email_sender_name: "",
      email_sender_address: "",
      country_id: "",
      moloni_id: "",
    });

    setErrors("");
  };
  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("searchValue");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    const storedSearch = localStorage.getItem("searchValue") || "";

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
      page: savedPage ? parseInt(savedPage, 10) : 1,
    }));
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value);
      localStorage.removeItem("lastVisitedPage");
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
      localStorage.setItem("lastVisitedPage", e.selected + 1);
    }
    setParams(paramsObj);
  };

  const fetchTemplate = () => {
    let data = { ...params };
    getWarehouseList(data)
      .then((response) => {
        setWarehouseList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };

      fetchTemplate(data);
    },
    [params],
  );

  const handleWareHouseSync = () => {
    setIsWareHouseLoading(true);

    let data = { company_id: "269134" };
    getAllWarehouseSync(data)
      .then((response) => {
        toast.success(response.data.message);

        let data = { ...params };
        getWarehouseList(data)
          .then((response) => {
            setWarehouseList(response.data.data);
            setTotalRecords(response.data.total);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
          })
          .finally(() => {
            setIsWareHouseLoading(false);
          });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsWareHouseLoading(false);
      });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTimeZoneList(list);
      })
      .catch((err) => {});
  }, []);

  const onDeleteModalClose = () => {
    setDelModal(false);
  };
  const onEditDetails = (e, item) => {
    setModifyModal(true);
    setWarehouseData({
      id: item?.id,
      title: item?.title,
      is_default: item?.is_default,
      code: item?.code,
      address: item?.address,
      city: item?.city,
      zip_code: item?.zip_code,
      phone: item?.phone,
      fax: item?.fax,
      contact_name: item?.contact_name,
      contact_email: item?.contact_email,
      country_id: item?.country_id,
      moloni_id: item?.moloni_id,
      notes: item?.notes,
    });
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelType(item.moloni_id);
    setDelModal(true);
  };

  const onDestroyBank = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { warehouse_id: delType, company_id: "269134" };
    deleteWarehouse(data)
      .then((response) => {
        let data = { ...params };

        fetchTemplate(data);
        toast.success(response.data.message);
        setDelType("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    if (!wareHouseData.title) {
      errorObj.title = `Title is required.`;
      error = true;
    }

    if (!wareHouseData.code) {
      errorObj.code = `Code is required.`;
      error = true;
    }

    if (!wareHouseData.address) {
      errorObj.address = `Address is required.`;
      error = true;
    }

    if (!wareHouseData.city) {
      errorObj.city = `City is required.`;
      error = true;
    }

    if (!wareHouseData.zip_code) {
      errorObj.zip_code = `Zip code is required.`;
      error = true;
    }

    if (!wareHouseData.country_id) {
      errorObj.country_id = `Country is required.`;
      error = true;
    }

    if (wareHouseData.contact_email) {
      const isValidGmail = /^[a-zA-Z0-9._%+-]+@gmail\.com$/.test(
        wareHouseData.contact_email,
      );
      if (!isValidGmail) {
        errorObj.contact_email =
          "Email must be a valid Gmail address (e.g., name@gmail.com)";
        error = true;
      }
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    setIsModifyButtonLoad(true);

    let data = {
      company_id: "269134",
      title: wareHouseData?.title,
      code: wareHouseData?.code,
      address: wareHouseData?.address,
      city: wareHouseData?.city,
      zip_code: wareHouseData?.zip_code,
      phone: wareHouseData?.phone,
      fax: wareHouseData?.fax,
      contact_name: wareHouseData?.contact_name,
      contact_email: wareHouseData?.contact_email,
      country_id: wareHouseData?.country_id,
      is_default: wareHouseData?.is_default,
    };

    let updateData = {
      company_id: "269134",
      id: wareHouseData?.id,
      title: wareHouseData?.title,
      code: wareHouseData?.code,
      address: wareHouseData?.address,
      city: wareHouseData?.city,
      zip_code: wareHouseData?.zip_code,
      phone: wareHouseData?.phone,
      fax: wareHouseData?.fax,
      contact_name: wareHouseData?.contact_name,
      contact_email: wareHouseData?.contact_email,
      country_id: wareHouseData?.country_id,
      is_default: wareHouseData?.is_default,
      warehouse_id: wareHouseData?.moloni_id,
    };

    if (wareHouseData?.id) {
      updateWarehouse(updateData)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchTemplate(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setWarehouseData({
            id: "",
            title: "",
            is_default: 0,
            code: "",
            address: "",
            city: "",
            zip_code: "",
            country_id: "",
            phone: "",
            fax: "",
            contact_name: "",
            contact_email: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createWarehouse(data)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchTemplate(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setWarehouseData({
            id: "",
            title: "",
            is_default: 0,
            code: "",
            address: "",
            city: "",
            zip_code: "",
            country_id: "",
            phone: "",
            fax: "",
            contact_name: "",
            contact_email: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  const handleCheckboxDefaultChange = (e) => {
    setWarehouseData({
      ...wareHouseData,
      is_default: e.target.checked ? 1 : 0,
    });
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid container-custom-height-new">
            <div className="row mb-2">
              <div className="col-sm-12 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-settings")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
                <h1 className="page-title ms-auto mb-2">{t("warehouses")}</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left"
                      style={{ width: "50%" }}
                    >
                      <input
                        type="text"
                        className="form-control input-search"
                        value={params.search}
                        onChange={(e) => handleParams(e, "search")}
                        placeholder="Search"
                      ></input>
                    </div>

                    <div className="card-title m-0 float-right d-flex">
                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        onClick={() => {
                          navigate("/add-warehouses");
                        }}
                      >
                        <i className="bi bi-plus-lg"></i>
                        <span className="ms-2">{t("Add")}</span>
                      </button>
                      {activeTab === "moloni" && (
                        <button
                          type="button"
                          className="btn mr-2"
 style={{
                            background: "#81bb42",
                            width: "52px",
                            height: "36px",
                          }}                          onClick={handleWareHouseSync}
                          disabled={isWareHouseLoading}
                        >
                          {isWareHouseLoading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            <i className="bi bi-arrow-repeat"></i>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="card-body fuelCardB">
                    <div className="tabs-section">
                      <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              activeTab === "tpsoft" ? "active" : ""
                            }`}
                            onClick={() => handleTabChange("tpsoft")}
                            style={{ cursor: "pointer" }}
                          >
                            TPSoft
                          </a>
                        </li>

                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              activeTab === "moloni" ? "active" : ""
                            }`}
                            onClick={() => handleTabChange("moloni")}
                            style={{ cursor: "pointer" }}
                          >
                            Moloni
                          </a>
                        </li>
                      </ul>

                      <div className="tab-content">
                        <div
                          className={`tab-pane fade ${
                            activeTab === "tpsoft" ? "show active" : ""
                          }`}
                        >
                          <div
                            className="vehicleThBg table-responsive table-responsive-vehicle"
                            style={{ marginTop: "15px" }}
                          >
                            <table className="table table-bordered rounded-table table table-striped table-hover">
                              <thead>
                                <tr>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("title")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("is_default")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("phone")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("contact_name")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("contact_email")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "0%" }}
                                  >
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {warehouseList?.map((item, index) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{item.title}</td>
                                        <td>
                                          {item.is_default === 1 ? "Yes" : "No"}
                                        </td>
                                        <td>{item.phone}</td>
                                        <td>{item.contact_name || "-"}</td>
                                        <td>{item.contact_email}</td>

                                        <td className="d-flex">
                                          <Dropdown
                                            className="iconDropdown"
                                            onToggle={(isOpen) => {
                                              if (isOpen) {
                                                // This logic runs when the dropdown is opened
                                                const tableResponsive =
                                                  document.querySelector(
                                                    ".table-responsive",
                                                  );
                                                if (window.innerWidth <= 767) {
                                                  if (tableResponsive) {
                                                    tableResponsive.style.overflowX =
                                                      "auto !important";
                                                    tableResponsive.style.overflowY =
                                                      "auto !important";
                                                  }
                                                } else {
                                                  if (tableResponsive) {
                                                    tableResponsive.style.overflowX =
                                                      "inherit !important";
                                                    tableResponsive.style.overflowY =
                                                      "inherit !important";
                                                  }
                                                }
                                              }
                                            }}
                                          >
                                            <Dropdown.Toggle
                                              variant="success"
                                              id="dropdown-basic"
                                              className="iconToggle"
                                            >
                                              <i className="bi bi-three-dots-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                href="#/action-1"
                                                className="d-flex"
                                                onClick={() =>
                                                  navigate(
                                                    `/update-warehouses/${item.id}`,
                                                    {
                                                      state: item,
                                                    },
                                                  )
                                                }
                                              >
                                                <div className="edit-btn">
                                                  <i className="bi bi-pencil"></i>
                                                </div>
                                                <span>{t("edit")}</span>
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                href="#/action-2"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onDeleteModalOpen(e, item)
                                                }
                                              >
                                                <div className="trash-btn">
                                                  <a className="delete-btn">
                                                    <i className="bi bi-trash3"></i>
                                                  </a>
                                                </div>
                                                <span>{t("delete")}</span>
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                              {warehouseList && warehouseList?.length === 0 && (
                                <tr>
                                  <td colSpan={7} className={`text-center`}>
                                    {t("no_record_found")}
                                  </td>
                                </tr>
                              )}
                            </table>
                          </div>
                        </div>

                        <div
                          className={`tab-pane fade ${
                            activeTab === "moloni" ? "show active" : ""
                          }`}
                        >
                          <div className="vehicleThBg table-responsive table-responsive1 table-responsive-vehicle mt-4">
                            <table className="table table-bordered rounded-table table table-striped table-hover">
                              <thead>
                                <tr>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("title")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("is_default")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("phone")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("contact_name")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("contact_email")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "0%" }}
                                  >
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {warehouseList?.map((item, index) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{item.title}</td>
                                        <td>
                                          {item.is_default === 1 ? "Yes" : "No"}
                                        </td>

                                        <td>{item.phone}</td>
                                        <td>{item.contact_name || "-"}</td>
                                        <td>{item.contact_email}</td>

                                        <td className="d-flex">
                                          <Dropdown
                                            className="iconDropdown"
                                            onToggle={(isOpen) => {
                                              if (isOpen) {
                                                // This logic runs when the dropdown is opened
                                                const tableResponsive1 =
                                                  document.querySelector(
                                                    ".table-responsive1",
                                                  );

                                                if (window.innerWidth <= 767) {
                                                  if (tableResponsive1) {
                                                    tableResponsive1.style.overflowX =
                                                      "auto !important";
                                                    tableResponsive1.style.overflowY =
                                                      "auto !important";
                                                  }
                                                } else {
                                                  if (tableResponsive1) {
                                                    tableResponsive1.style.overflowX =
                                                      "inherit !important";
                                                    tableResponsive1.style.overflowY =
                                                      "inherit !important";
                                                  }
                                                }
                                              }
                                            }}
                                          >
                                            <Dropdown.Toggle
                                              variant="success"
                                              id="dropdown-basic"
                                              className="iconToggle"
                                            >
                                              <i className="bi bi-three-dots-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                href="#/action-1"
                                                className="d-flex"
                                                onClick={() =>
                                                  navigate(
                                                    `/update-warehouses/${item.id}`,
                                                    {
                                                      state: item,
                                                    },
                                                  )
                                                }
                                              >
                                                <div className="edit-btn">
                                                  <i className="bi bi-pencil"></i>
                                                </div>
                                                <span>{t("edit")}</span>
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                href="#/action-2"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onDeleteModalOpen(e, item)
                                                }
                                              >
                                                <div className="trash-btn">
                                                  <a className="delete-btn">
                                                    <i className="bi bi-trash3"></i>
                                                  </a>
                                                </div>
                                                <span>{t("delete")}</span>
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                              {warehouseList && warehouseList?.length === 0 && (
                                <tr>
                                  <td colSpan={7} className={`text-center`}>
                                    {t("no_record_found")}
                                  </td>
                                </tr>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="fuelCF">
            <div
              className="card-footer card-footer-part clearfix card-footer"
              style={{ marginTop: "-26px" }}
            >
              <div className="pagination pagination-sm m-0 float-right">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{t("delete_warehouses")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>
            {t("Are you sure you want to delete this warehouses")}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestroyBank}
            >
              {t("delete")} <i className="bi bi-trash3"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyModal} size="xl">
        <ModalHeader>{t("warehouses")}</ModalHeader>
        <Form method={`post`} onSubmit={handleSubmitForm}>
          <ModalBody>
            <div className="row">
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("title")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={wareHouseData.title}
                        onChange={(e) => {
                          setWarehouseData({
                            ...wareHouseData,
                            title: e.target.value,
                          });
                        }}
                        name={`title`}
                        maxLength={50}
                        placeholder="title"
                      />
                    </div>
                    {errors.title && (
                      <span className="input-error">{errors.title}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("code")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={wareHouseData.code}
                        onChange={(e) => {
                          setWarehouseData({
                            ...wareHouseData,
                            code: e.target.value,
                          });
                        }}
                        name={`code`}
                        maxLength={50}
                        placeholder="Code"
                      />
                    </div>
                    {errors.code && (
                      <span className="input-error">{errors.code}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("address")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={wareHouseData.address}
                        onChange={(e) => {
                          setWarehouseData({
                            ...wareHouseData,
                            address: e.target.value,
                          });
                        }}
                        name={`address`}
                        maxLength={50}
                        placeholder="Address"
                      />
                    </div>
                    {errors.address && (
                      <span className="input-error">{errors.address}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("city")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={wareHouseData.city}
                        onChange={(e) => {
                          setWarehouseData({
                            ...wareHouseData,
                            city: e.target.value,
                          });
                        }}
                        name={`city`}
                        maxLength={50}
                        placeholder="City"
                      />
                    </div>
                    {errors.city && (
                      <span className="input-error">{errors.city}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("zip_code")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={wareHouseData.zip_code}
                        onChange={(e) => {
                          setWarehouseData({
                            ...wareHouseData,
                            zip_code: e.target.value,
                          });
                        }}
                        name={`zip_code`}
                        maxLength={50}
                        placeholder="Zip code"
                      />
                    </div>
                    {errors.zip_code && (
                      <span className="input-error">{errors.zip_code}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("phone")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        value={wareHouseData.phone}
                        onChange={(e) => {
                          setWarehouseData({
                            ...wareHouseData,
                            phone: e.target.value,
                          });
                        }}
                        name={`phone`}
                        placeholder="Phone"
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("fax")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        value={wareHouseData.fax}
                        onChange={(e) => {
                          setWarehouseData({
                            ...wareHouseData,
                            fax: e.target.value,
                          });
                        }}
                        name={`fax`}
                        placeholder="Fax"
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("contact_name")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={wareHouseData.contact_name}
                        onChange={(e) => {
                          setWarehouseData({
                            ...wareHouseData,
                            contact_name: e.target.value,
                          });
                        }}
                        name={`contact_name`}
                        maxLength={50}
                        placeholder="Contact name"
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("contact_email")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={wareHouseData.contact_email}
                        onChange={(e) => {
                          setWarehouseData({
                            ...wareHouseData,
                            contact_email: e.target.value,
                          });
                        }}
                        name={`contact_email`}
                        maxLength={50}
                        placeholder="Contact email"
                      />
                      {errors.contact_email && (
                        <span className="input-error">
                          {errors.contact_email}
                        </span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("country")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={timeZoneList}
                        value={timeZoneList.find(
                          (item) => item.value == wareHouseData.country_id,
                        )}
                        onChange={(selectedOption) => {
                          setWarehouseData({
                            ...wareHouseData,
                            country_id: selectedOption
                              ? selectedOption.value
                              : "",
                          });
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder={"Select Country"}
                      />
                      {errors.country_id && (
                        <span className="input-error">{errors.country_id}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {t("is_default")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <div className="form-check">
                        <input
                          className="my-checkbox-1 form-check-input"
                          type="checkbox"
                          checked={wareHouseData.is_default === 1}
                          onChange={handleCheckboxDefaultChange}
                        />
                        <label className="form-check-label pl-6">
                          {t("is_default")}
                        </label>
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3"></div>
              <div className="col-md-3"></div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isModifyButtonLoad}
              onClick={handleCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
            {!isModifyButtonLoad && (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("submit")} <i className="bi bi-check2"></i>
              </button>
            )}
            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default WarehouseMoloni;
